export function viewInvoiceInXero(InvoiceId){
	window.open(process.env.MIX_XERO_INVOICES_BASE_URL + '/' + InvoiceId, '_blank');
}